// Week 7 / Day 3 — Ресурсы, материалы и эффективность / Resources, Materials and Efficiency
// Solid Grade 6 math + RU Grade 3–4.

export const maxWeek7Day3 = {
  id: 'max-week-7-day-3',
  studentId: 'max',
  weekId: 'week-7',
  dayId: 'day-3',
  title: 'Ресурсы, материалы и эффективность / Resources, Materials and Efficiency',
  shortTitle: 'Ресурсы и эффективность / Resources and Efficiency',
  theme:
    'Макс сравнивает ресурсы, материалы и эффективность двух команд. / Max compares resources, materials and team efficiency.',
  estimatedTimeLabel: 'Онлайн: 25–35 мин. Полный день: 80–100 мин. / Online: 25–35 min. Full day: 80–100 min.',
  nimnyIntro:
    'Нимни ведёт Макса через материалы, unit rate двух команд, процент экономии и уравнение материалов. / Nimny walks Max through materials, unit rate, savings % and a material equation.',
  goals: [
    'Слой 1. Математика / Layer 1. Math: остатки, unit rate, проценты экономии, уравнение (Grade 6). / balances, unit rate, savings %, equation.',
    'Слой 2. Русский / Layer 2. Russian: безударные, части речи, исправление.',
    'Слой 3. Чтение и письмо / Layer 3. Reading: короткий текст о материалах и качестве + план + 4 предложения.',
    'Слой 4. Логика и анализ данных / Layer 4. Logic and data analysis: экономия vs красота работы.',
    'Слой 5. Практика: план 1 проекта с материалами и остатками. / Practical: 1-project plan with materials and balance.',
    'Дневник мышления / Thinking Diary.',
    'Награда нимами / Reward in nims: 3/5.'
  ],
  vocabulary: [
    { term: 'ресурс / resource', definition: 'то, что нужно для работы / what is needed for the work' },
    { term: 'материал / material', definition: 'предмет для проекта: бумага, наклейки / an item for the project: paper, stickers' },
    { term: 'экономия / savings', definition: 'сколько ресурсов удалось сберечь / how many resources saved' },
    { term: 'эффективность / efficiency', definition: 'сколько результата за 1 минуту / result per minute' },
    { term: 'остаток / balance', definition: 'сколько ресурсов осталось / what remains' },
    { term: 'уравнение / equation', definition: 'равенство с x / equality with x' }
  ],
  onlineTasks: [
    { id: 'q1', type: 'math', title: 'Материалы и остаток / Materials balance',
      prompt: 'Было 80 листов и 55 наклеек. Осталось 14 листов и 9 наклеек. Сколько использовано? / Used = starting − remaining.',
      helper: 'Вычитание. / Subtract.',
      answer: '66 листов и 46 наклеек. / 66 sheets, 46 stickers.', unit: '' },
    { id: 'q2', type: 'math', title: 'Эффективность двух команд / Team efficiency',
      prompt: 'A: 36 карточек за 90 мин. B: 28 карточек за 56 мин. У какой карточек за 1 минуту больше? / Cards/min for each.',
      helper: 'Карточки ÷ минуты. / Cards / minutes.',
      answer: 'B эффективнее (0.5 vs 0.4). / B is faster.', unit: 'карт/мин / cards/min' },
    { id: 'q3', type: 'math', title: 'Процент экономии ресурсов / Savings percent',
      prompt: 'Обычно 80 листов. Использовано 68. На сколько процентов сэкономлено? / Saved % vs standard 80.',
      helper: 'Экономия ÷ обычное. / Saved / standard.',
      answer: '15%. / 15%.', unit: '%' },
    { id: 'q4', type: 'math', title: 'Уравнение материалов / Materials equation',
      prompt: '3 одинаковых набора + 12 дополнительных листов = 84 листа. Сколько в наборе? Сколько нужно на 5 наборов? / 3x + 12 = 84; then 5x.',
      helper: 'Реши уравнение, потом умножь. / Solve, then multiply.',
      answer: '24 листа в наборе; 5 наборов = 120 листов. / 24 each; 120 total.', unit: 'листов / sheets' },
    { id: 'q5', type: 'classify', title: 'Части речи / Parts of speech',
      prompt: 'Распредели по частям речи. / Sort by part of speech.',
      categories: [
        { id: 'noun', label: 'Существительное / Noun' },
        { id: 'verb', label: 'Глагол / Verb' },
        { id: 'adj', label: 'Прилагательное / Adjective' }
      ],
      items: [
        { id: 'w1', text: 'материал / material' },
        { id: 'w2', text: 'бережный / careful' },
        { id: 'w3', text: 'использовать / to use' },
        { id: 'w4', text: 'ресурс / resource' },
        { id: 'w5', text: 'аккуратный / neat' },
        { id: 'w6', text: 'экономить / to save' }
      ] },
    { id: 'q6', type: 'text', title: 'Исправь ошибки / Fix mistakes',
      prompt: 'Перепиши без ошибок: «мы стараемся использывать материалы бережно и не выбрасывать нужные вещи». / Rewrite without mistakes.',
      placeholder: 'Мы стараемся... / We try...' },
    { id: 'q7', type: 'text', title: 'Главная мысль и план / Main idea and plan',
      prompt: 'Прочитай текст «Материалы, экономия и качество» на печатном листе. Запиши главную мысль, план из 3 пунктов и 4 предложения. / Read; main idea + plan + 4 sentences.',
      placeholder: 'Главная мысль: ... / Main idea: ...' },
    { id: 'q8', type: 'text', title: 'Логика: экономия vs красота / Logic: savings vs beauty',
      prompt: 'Что лучше — меньше материалов или красивее результат? Как найти баланс? 2–4 предложения. / How to balance?',
      placeholder: 'Иногда... / Sometimes...' },
    { id: 'q9', type: 'essay', title: 'План 1 проекта / One project plan',
      prompt: 'Составь план 1 проекта: материалы, ожидаемый расход, остаток, эффективность (карточек/мин). / One project plan with materials, expected use, balance, cards/min.',
      minSentences: 4, maxSentences: 8, placeholder: 'Материалы: ... Расход: ... Остаток: ... Эффективность: ...' }
  ],
  notebookInstructions: [
    'Заголовок: «Неделя 7, День 3». / Heading.',
    'Слой 1. Математика: q1–q4. / Math.',
    'Слой 2. Русский: части речи + исправление. / Russian.',
    'Слой 3. Чтение: главная мысль + план + 4 предложения. / Reading.',
    'Слой 4. Логика: экономия vs красота. / Logic.',
    'Слой 5. Практика: план 1 проекта. / Practical.',
    'Дневник мышления / Thinking diary.',
    'Награда нимами. / Reward.'
  ],
  printWorksheet: {
    title: 'Неделя 7, День 3 / Week 7, Day 3',
    subtitle: 'Ресурсы, материалы и эффективность / Resources, Materials and Efficiency',
    pages: [
      { title: 'Маршрут дня: пять слоёв обучения / Daily route: five learning layers', blocks: [
        { type: 'list', items: [
          '1. Математика / Math — 30–35 мин / min.',
          '2. Русский язык / Russian — 15–20 мин / min.',
          '3. Чтение и письмо / Reading and writing — 10–15 мин / min.',
          '4. Логика и анализ данных / Logic and data analysis — 5–10 мин / min.',
          '5. Практика: план 1 проекта / Practical: 1 project plan — 10–15 мин / min.',
          '6. Дневник мышления / Thinking diary — 5 мин / min.',
          '7. Награда нимами / Reward in nims.'
        ] }
      ] },
      { title: 'Слой 1. Математика / Layer 1. Math', blocks: [
        { type: 'text', text: 'Grade 6: остатки, unit rate, проценты экономии, уравнение. Показывай шаги. / Show steps.' },
        { type: 'list', items: [
          '1) Листы: 80 − 14 = ____. Наклейки: 55 − 9 = ____. / Balance.',
          '2) A: 36 ÷ 90 = ____ карт/мин. B: 28 ÷ 56 = ____ карт/мин. Быстрее: ____ (потому что ____ > ____). / Unit rate.',
          '3) Экономия: 80 − 68 = ____. Процент: ____ ÷ 80 = ____ = ____%. / Savings %.',
          '4) 3x + 12 = 84. 3x = ____. x = ____. 5 × ____ = ____ листов. / Equation.',
          '5) Проверка / Check: 24 × 3 + 12 = ____ = 84? / Verify.',
          '6) Если 5% экономии от 80 листов, экономия = ____ листов. / 5% of 80.',
          '7) Optional / Доп.: 46 наклеек за 92 мин = ____ наклеек/мин. / Extra rate.',
          '8) Optional / Доп.: если 68 = 85% от нормы, норма = 68 ÷ 0.85 = ____ листов. / Extra inverse.'
        ] }
      ] },
      { title: 'Слой 2. Русский язык и правописание / Layer 2. Russian Language and Spelling', blocks: [
        { type: 'text', text: 'Правило / Rule: части речи по вопросу; безударные проверяем ударением. / Parts of speech + unstressed.' },
        { type: 'list', items: [
          'Словарь / Vocabulary: материал, ресурс, экономия, эффективность, остаток, качество, польза, план.',
          'Части речи / Parts of speech: материал, бережный, использовать, ресурс, аккуратный, экономить — раздели.',
          'Исправь ошибки / Fix mistakes: «мы стараемся использывать материалы бережно и не выбрасывать нужные вещи».',
          'Мини-диктант / Mini-dictation: «Мы стараемся использовать материалы бережно и не выбрасывать нужные вещи».',
          'Орфограмма дня / Spelling rule: безударные в корне; парные согласные. / Unstressed + paired consonants.'
        ] }
      ] },
      { title: 'Слой 3. Чтение, письмо и пересказ / Layer 3. Reading, Writing and Retelling', blocks: [
        { type: 'list', items: [
          'Текст «Материалы, экономия и качество» / Text: Хорошая работа — это не «дороже», а «точнее». Если Макс использует меньше листов и наклеек, но результат остаётся качественным, это правильная экономия. Настоящая проверка простая: сравни план и остаток. Если остаток разумный, значит, ресурсов хватило на дело, а не ушло в мусор. Так экономия становится частью качества, а не заменой ему. / Good work is not "more expensive" but "more precise". Saving materials while keeping quality is right. Compare plan and balance: if balance is reasonable, resources went to the work, not to trash.',
          'Главная мысль / Main idea: __________________________________',
          'План из 3 пунктов / 3-point plan: 1) ______ 2) ______ 3) ______',
          '4 своих предложения о материалах / 4 sentences: ______________________________',
          'Пересказ родителю 3–5 предложений по-русски / Retell in 3–5 Russian sentences ✓.'
        ] }
      ] },
      { title: 'Слой 4. Логика и анализ данных / Layer 4. Logic and Data Analysis', blocks: [
        { type: 'text', text: 'Сравни: A — сэкономил 20% ресурсов, но работа скучная; B — потратил всё, но получилось красиво. / A vs B.' },
        { type: 'list', items: [
          'Что важно в реальном проекте: обе стороны или только одна? / One or both?',
          'Как измерить «красоту» результата? (например, оценка 1–10) / How to measure beauty?',
          'Мой аргумент / My argument: __________________________________',
          'Вывод / Conclusion: экономия и качество — две шкалы, а не одна. / Two axes, not one.',
          'Как выбрать компромисс? / How to choose the compromise?'
        ] }
      ] },
      { title: 'Слой 5. Практические знания: план 1 проекта / Layer 5. Practical Knowledge: 1 project plan', blocks: [
        { type: 'text', text: 'Составь план для одного учебного проекта. / Draft a plan for one learning project.' },
        { type: 'list', items: [
          'Проект / Project: __________________________________',
          'Материалы / Materials: листов ____; наклеек ____; другое ____.',
          'Ожидаемый расход / Expected use: листов ____; наклеек ____.',
          'Остаток / Balance: листов ____; наклеек ____.',
          'Эффективность / Efficiency: карточек ____ ÷ минут ____ = ____ карт/мин.',
          'Оценка качества 1–10 (учебная) / Quality 1–10 (learning): ____.',
          'Вывод / Conclusion: __________________________________'
        ] }
      ] },
      { title: 'Дневник мышления / Thinking Diary', blocks: [
        { type: 'list', items: [
          'Что я понял про экономию / What I learned about savings: ______',
          'Самое важное слово / Most important word: ______'
        ] }
      ] },
      { title: 'Родительская проверка и награда нимами / Parent check and reward in nims', blocks: [
        { type: 'list', items: [
          'Базовая награда / Base reward: 3 нима / nims ✓',
          'Бонус за unit rate и экономию / Bonus for unit rate + savings: +1 ☐',
          'Бонус за понятный план проекта / Bonus for a clear project plan: +1 ☐',
          'Итого / Total: ____ из / of 5 нимов / nims'
        ] }
      ] }
    ]
  },
  parentGuide: {
    goal:
      'Grade 6: остатки; unit rate 0.4 vs 0.5; экономия 15%; уравнение 3x + 12 = 84 → 24; 5×24 = 120. Русский Grade 3–4. / Solid Grade 6 + Grade 3–4 Russian.',
    mathGoal: 'q1: 66 и 46. q2: 0.4 vs 0.5; B. q3: 15%. q4: 24; 120. / Listed with steps.',
    russianGoal: 'Существительные: материал, ресурс. Глаголы: использовать, экономить. Прилагательные: бережный, аккуратный. / Correct sorting.',
    readingWritingGoal: 'Главная мысль: экономия часть качества, а не замена ему. / Main idea + plan + 4 sentences.',
    practicalGoal: 'План одного проекта с материалами, остатком и эффективностью. / One-project plan.',
    check: [
      'Q1: 66 листов и 46 наклеек.',
      'Q2: B (0.5 > 0.4 карт/мин).',
      'Q3: 15%.',
      'Q4: 24 и 120 листов.',
      'Части речи разобраны. / Parts of speech.',
      'Главная мысль + план + 4 предложения. / Main idea + plan + 4 sentences.',
      'Логика экономия vs красота. / Savings vs beauty.',
      'План проекта с материалами. / Project plan.'
    ],
    answerKey: [
      { taskId: 'q1', answer: 'Листы: 80 − 14 = 66. Наклейки: 55 − 9 = 46. / 66 sheets; 46 stickers.' },
      { taskId: 'q2', answer: 'A: 36 ÷ 90 = 0.4 карт/мин; B: 28 ÷ 56 = 0.5 карт/мин; B эффективнее.' },
      { taskId: 'q3', answer: '80 − 68 = 12; 12 ÷ 80 = 0.15 = 15%.' },
      { taskId: 'q4', answer: '3x + 12 = 84; 3x = 72; x = 24; 5 × 24 = 120.' },
      { taskId: 'q5', answer: 'Существительные: материал, ресурс. Глаголы: использовать, экономить. Прилагательные: бережный, аккуратный.' },
      { taskId: 'q6', answer: 'Мы стараемся использовать материалы бережно и не выбрасывать нужные вещи.' },
      { taskId: 'q7', answer: 'Главная мысль: экономия часть качества. План: 1) точность важнее дороговизны; 2) сравни план и остаток; 3) остаток разумный. 4 предложения — открытый ответ.' },
      { taskId: 'q8', answer: '2–4 предложения: экономия и красота — две шкалы; ищем компромисс через план и остаток. / Two axes; compromise via balance.' },
      { taskId: 'q9', answer: 'Открытый ответ: материалы, расход, остаток, эффективность. / Open answer.' }
    ],
    spellingCheck: 'Безударные и парные согласные правильно. / Unstressed + paired.',
    readingCheck: 'Главная мысль ясная; план 3 пункта; 4 предложения; пересказ 3–5 предложений. / Main idea + plan + retelling.',
    notebookCheck: 'Все 5 слоёв заполнены. / All 5 layers.',
    printCheck: 'Все 8 страниц заполнены. / All 8 pages.',
    discussionPrompts: [
      'Как ты понимаешь, что экономия честная? / How to know the savings are honest?',
      'Что важнее для тебя — процесс или результат? / Process or result?',
      'Когда экономия становится вредной? / When is saving harmful?',
      'Как найти баланс между временем, ресурсами и качеством? / How to balance time / resources / quality?'
    ],
    ifEasy: 'Усложни: пересчитай процент экономии, если норма 100, расход 78. / Extend: savings % with 100/78.',
    ifDifficult: 'Оставь q1 и q4. / Keep q1 and q4.',
    tokenReward:
      'После проверки можно начислить бонусные нимы через Parent Room. Нимы — это призовые токены курса, а не оплата. / Nims are course prize tokens, not payment.'
  },
  reward: {
    unit: 'nim', unitName: 'ним', base: 3, max: 5,
    label: 'Награда за завершение / Completion reward', display: '3 нима / 3 nims',
    bonuses: [
      { id: 'rate-savings', label: 'Бонус за unit rate и экономию / Bonus for unit rate + savings', amount: 1 },
      { id: 'clean-plan', label: 'Бонус за понятный план проекта / Bonus for a clear project plan', amount: 1 }
    ]
  },
  completionRequirements: { requiredTaskIds: ['q1', 'q4', 'q7', 'q9'], allowNotebookCompletion: true },
  unlockAfter: { weekId: 'week-7', dayId: 'day-2' },
  nextLessonId: 'max-week-7-day-4'
};

export default maxWeek7Day3;
